// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1by5m","footer":"ModalUpdate_footer__2vAEk"};